const LocalStorageMap = {
    JWT_TOKEN: 't'
};

export default LocalStorageMap;
